// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('FollowPeopleSocialAuthCard')

class FollowPeopleSocialAuthCard extends React.PureComponent {

  renderHeading() {
    return (
      tag('div', {
        className: bem.element('heading')
      },
        'Find people you know'
      )
    )
  }

  renderSubheading() {
    return (
      tag('div', {
        className: bem.element('subheading')
      },
        'You choose which friends to follow. ',
        'We will never post without your permission.'
      )
    )
  }

  renderFacebookButton() {
    if (!this.props.facebookHref) {
      return null
    }
    return (
      tag('a', {
        className: bem.element('button', 'facebook'),
        href: this.props.facebookHref,
        onClick: this.props.onFacebookClick
      },
        tag('span', { className: bem.element('icon', 'facebook') }),
        'Connect to Facebook'
      )
    )
  }

  renderTwitterButton() {
    if (!this.props.twitterHref) {
      return null
    }
    return (
      tag('a', {
        className: bem.element('button', 'twitter'),
        href: this.props.twitterHref,
        onClick: this.props.onTwitterClick
      },
        tag('span', { className: bem.element('icon', 'twitter') }),
        'Connect to Twitter'
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        tag('div', {
          className: bem.element('inner')
        },
          this.renderHeading(),
          this.renderSubheading(),
          this.renderFacebookButton(),
          this.renderTwitterButton()
        )
      )
    )
  }

}

FollowPeopleSocialAuthCard.propTypes = {
  // Values
  className: PropTypes.string,
  facebookHref: PropTypes.string,
  twitterHref: PropTypes.string,
  // Callbacks
  onFacebookClick: PropTypes.func,
  onTwitterClick: PropTypes.func
}

module.exports = FollowPeopleSocialAuthCard
